import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "permission" }
const _hoisted_2 = { class: "permission-other" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { reactive, ref } from 'vue'
import { getListData } from '@/service/main/system'
import { ElForm } from 'element-plus'

import { initEmptyParam } from '@/hooks/useInitParam'


export default /*#__PURE__*/_defineComponent({
  __name: 'permission',
  setup(__props) {

initEmptyParam()

const permissions = ref<any[]>([])
const getAllPermission = async () => {
  let data = await getListData('/main/permission/listAll', { pageSize: 20 })
  const permList: any[] = data.list
  permList.forEach((item: any) => {
    item.permissions.forEach((child: any) => {
      delete child.permissions
    })
  })

  permissions.value = permList
}

getAllPermission()

const formRef = ref<InstanceType<typeof ElForm>>()

const otherInfo = reactive({
  type: '',
  uri: '',
  value: '',
  icon: '',
  pid: '',
  path: '',
})
const rules = {
  type: [{ required: true, message: '权限类型必填', trigger: 'blur' }],
  uri: [{ required: true, message: '资源路径必填', trigger: 'blur' }],
  value: [{ required: true, message: '权限值必填', trigger: 'blur' }],
  icon: [{ required: true, message: '目录图标必填', trigger: 'blur' }],
  pid: [{ required: true, message: '请选择上级权限', trigger: 'blur' }]
}

const modalTitle = ref('新增')

const newCb = () => {
  getAllPermission()
  modalTitle.value = '新增权限'
  otherInfo.type = ''
  otherInfo.uri = ''
  otherInfo.value = ''
  otherInfo.icon = ''
  otherInfo.pid = ''
  otherInfo.path = ''
}

const editCb = (item: any) => {
  getAllPermission()
  modalTitle.value = '编辑权限'
  otherInfo.type = item.type
  otherInfo.uri = item.uri
  otherInfo.value = item.value
  otherInfo.icon = item.icon
  otherInfo.pid = item.pid
  otherInfo.path = item.path
}

const handleValid = () => {
  return formRef.value?.validate().then(
    (isValid) => {
      return isValid
    },
    () => {
      return false
    }
  )
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "permission",
      deleteTip: "确认删除此权限吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      pageSize: "20"
    }, {
      status: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "mini",
          plain: "",
          type: scope.row.status == 1 ? 'success' : 'danger'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.status == 1 ? '正常' : '禁用'), 1)
          ]),
          _: 2
        }, 1032, ["type"])
      ]),
      icon: _withCtx((scope) => [
        _createElementVNode("span", {
          class: _normalizeClass(scope.row.icon)
        }, null, 2)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "permission",
      otherInfo: otherInfo,
      validOtherInfo: handleValid
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(ElForm), {
            rules: rules,
            model: otherInfo,
            ref_key: "formRef",
            ref: formRef,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "权限类型",
                prop: "type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    placeholder: "请选择权限类型",
                    style: {"width":"100%"},
                    modelValue: otherInfo.type,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((otherInfo.type) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: "0",
                        label: "目录"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("目录")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        value: "1",
                        label: "菜单"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("菜单")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        value: "2",
                        label: "功能"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("功能")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (otherInfo.type === '2')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "权限值",
                    prop: "value"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: otherInfo.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((otherInfo.value) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (otherInfo.type === '0')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "目录图标",
                    prop: "icon"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: otherInfo.icon,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((otherInfo.icon) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (otherInfo.type === '1')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 2,
                    label: "资源路径",
                    prop: "uri"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: otherInfo.uri,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((otherInfo.uri) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (otherInfo.type === '1')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 3,
                    label: "资源路径匹配",
                    prop: "path"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: otherInfo.path,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((otherInfo.path) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (otherInfo.type === '1')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 4,
                    label: "上级权限",
                    prop: "pid"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        placeholder: "请选择上级权限",
                        style: {"width":"100%"},
                        modelValue: otherInfo.pid,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((otherInfo.pid) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissions.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              value: item.id,
                              label: item.name
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (otherInfo.type === '2')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 5,
                    label: "上级权限",
                    prop: "pid"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_cascader, {
                        options: permissions.value,
                        props: {
                children: 'permissions',
                label: 'name',
                value: 'id',
                emitPath: false
              },
                        placeholder: "请选择上级权限",
                        modelValue: otherInfo.pid,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((otherInfo.pid) = $event))
                      }, null, 8, ["options", "modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})